/**
 * "Chép sang màn" under the Ads Builder canvas: the caret beside Nhân bản, its list of the ad's other screens, and the toast that says it
 * was done (routes/playable-editor-copy-to-screen.tsx, routes/ads-builder-v2-build.tsx). Their siblings live in
 * playable-templates-keys.ts, which is over the line cap.
 */
export const playableCopy: Record<string, string> = {
  'playable.editor.copy.hint': 'Chép sang màn khác: chép các phần tử đang chọn sang một màn khác của quảng cáo, đúng vị trí cũ. Nhóm mang theo phần tử con; chữ đã dịch, giá trị đã ghim và thời gian hiệu ứng của chúng đi cùng. Màn đang xem không đổi.',
  'playable.editor.copy.alone': 'Chép sang màn khác: quảng cáo mới có một màn. Thêm màn nữa để chép phần tử sang.',
  'playable.editor.copy.menuTitle': 'Chép sang màn',
  'playable.editor.copy.blockedTag': 'chỉ xem',
  'playable.editor.copy.blocked': 'Màn này chưa sửa được nên chưa chép vào được. Màn dùng chung từ thư viện: chọn nó rồi bấm “Tạo bản riêng cho template này” (nếu có nút đó), sau đó chép.',
  'playable.editor.copy.done': 'Đã chép {n} phần tử sang “{name}”. Mở màn đó trên timeline để xem; Hoàn tác ở màn đó sẽ gỡ chúng ra.',
}
